import { observable } from 'mobx';
import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { PageTitle, FlightsPhrase } from '__generated__/api';
import FlightsMessage = FlightsPhrase.Fragment;

export interface PageTitleType {
  title: PageTitle.Title;
  disclaimerSubTitle?: PageTitle.DisclaimerSubTitle;
  date?: PageTitle.Date;
  pageAccessibility?: string;
}

export class PageTitleStore extends Store {
  @observable public pageTitle?: PageTitleType;
  @observable public loading: boolean;
  @observable public disclaimerSubTitleLoadingState?: FlightsMessage;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setLoading(isNewSearch: boolean): void {
    if (isNewSearch) {
      this.loading = true;
    }
  }

  public setDisclaimerSubTitleLoadingState(): void {
    if (this.loading) {
      this.disclaimerSubTitleLoadingState = this.pageTitle?.disclaimerSubTitle;
    }
  }
}

PageTitleStore.DEFAULTS = {
  loading: true
};
